import React from 'react';
import './Footer.scss';
import arrowBlue from '../../assets/images/Arrow-blue.svg';

const Footer = () => {
  return (
    <section className="footer" id="footer">
      <div className="footer__text-container">
        <h2>Feel free</h2>
        <h2>to contact me anytime</h2>
        <p>Based in Tel-Aviv, Israel</p>
      </div>
      <div className="footer__contacts-container">
        <div className="footer__contacts-portfolio">
          <a href="https://www.behance.net/krsgromov" target="_blank" rel="noreferrer">
            Behance
          </a>
          <a href="https://www.linkedin.com/in/krsgromov/" target="_blank" rel="noreferrer">
            LinkedIn
          </a>
        </div>
        <div className="footer__contacts-socials">
          <div className="footer__contacts-socials-content">
            <span>
              Get in touch
              <img src={arrowBlue} alt="Arrow" />
            </span>
            <p>krsgromov@gmail.com</p>
          </div>
          <div className="footer__contacts-socials-content">
            <a href="https://www.instagram.com/krsgromov/" target="_blank" rel="noreferrer">
              Instagram
              <img src={arrowBlue} alt="Arrow" />
            </a>
            <a href="https://www.instagram.com/krsgromov/" target="_blank" rel="noreferrer">
              {' '}
              <p>@krsgromov</p>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
